import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';
import { getShareTitles } from '../redux/sharesTitlesActions';

type UseGetShareTitlesProps = {
  societyId?: string;
  page?: number;
  rowsPerPage?: number;
  searchTerm?: string;
};

export const useGetShareTitles = ({
  societyId,
  page = 1,
  rowsPerPage = 10,
  searchTerm,
}: UseGetShareTitlesProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchShareTitles = useCallback(
    async (controller: AbortController) => {
      if (!societyId) return;

      try {
        setIsLoading(true);

        await store.dispatch(
          getShareTitles({
            societyId,
            params: {
              page,
              items: rowsPerPage,
              searchTerm,
            },
            includeRanges: true,
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [page, rowsPerPage, societyId, searchTerm]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchShareTitles(controller);

    return () => controller.abort();
  }, [fetchShareTitles]);

  return { isLoading, isError };
};
